export default class {
  constructor(args) {
    /* Set Args Or Defaults */
    this.url = args.url || '';
    this.nonce = args.nonce || '';
    this.action = args.action || '';
    this.term_id = args.term_id || '';
    this.parent = args.parent || '';

    /* Set Defaults by Load more */
    this.hasMore = false;
    this.currentPage = args.page || 1;
    this.maxItems = args.maxItems || 1;

    /* Init Elements */
    this.productsContainer = $('.container-article-product');
    this.loader = $('.ajax-loader');
    this.total = $('.content .main .toolbar-product span.found_posts');
    this.container = $('.container-article-product');

    /* Init Listeners */
    this._initListeners();

    //this.handleRequest()
  }

  _initListeners() {
    /* Hack for bind this */
    const self = this;

    $(document).on('click', '.click-filter', function () {
      self.handleFilter(this);
    });
    /* Author */
    $(document).on('click', '.order-filter', function (e) {
      self.handleChange(this, e);
    });

    /* Mobile Filters */
    $(document).on('click', '.order-filter', function () {
      self.handleDropdownMobileMenu(this);
    });

    /* OrderBy */
    $(document).on('click', '.sort-options', function () {
      self.handleOrderBy(this);
    });

    /* Filter */
    $(document).on('click', '.filter-item', function (e) {
      self.handleChange(this, e);
    });

    $(document).on('click', '.filter-category', function () {
      let id = $(this).data('value');
      $(`#category-${id}`).trigger('click');
    });

    /* Remove Selected filter */
    $(document).on('click', '.filter-remove', function (e) {
      self.removeArray(this, e);

    });

    $(document).on('click', '.search-author', e => {
      e.preventDefault();
    });
    /* Reset All Filters */
    $(document).on('click', 'button.clear', () => this.handleReset());

    /* Load More */
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) this.handleLoadMore();
    });
    this.observer.disconnect(); /* Remove previous Observers */
    this.observer.observe(document.querySelector('footer'));
  }

  getUrlParams(URLSearch = null) {
    return new URLSearchParams(URLSearch || window.location.search);
  }

  updateParameters(key, val = null, isUnique = false) {
    const urlParams = this.getUrlParams();
    /* Clear Param recently_purchased */
    urlParams.delete('recently_purchased');

    if (val === null) {
      urlParams.delete(key);
    } else if (urlParams.has(key) && !isUnique) {
      let values = urlParams.get(key).split(',');
      let index = values.indexOf(`${val}`);
      if (index > -1) {
        values.splice(index, 1);
      } else {
        values.push(val);
      }

      if (values.length === 0) urlParams.delete(key);
      else urlParams.set(key, values.toString());
    } else {
      let values = urlParams.get(key);
      if(values == val){
        urlParams.delete(key);
      }else{
        urlParams.set(key, val);
      }

    }

    history.pushState(
      {},
      '',
      `${location.pathname}${
        urlParams.toString().length > 0 ? `?${urlParams}` : ''
      }`
    );
  }

  handleFilter() {
    $('.dropdown-filter').toggleClass('active');
    $('.click-filter').toggleClass('icon');
  }

  handleDropdownMobileMenu(that) {
    const target = $($(that).data('target'));
    const height = target.find('.container-sub-menu').height();

    target.css('height', target.height() < 1 ? height + 20 : 0);
    $(that).toggleClass('icon');
  }

  handleChange(that, e) {
    e.preventDefault();

    const self = $(that);
    const key = self.data('key');
    const value = self.data('value');

    self.toggleClass('active');
    self.toggleClass('inactive');

    if ($('.filter-reset li').length > 0) $('.filter-reset').show();
    else $('.filter-reset').hide();

    if (key === 'category') $('.filter-type.categories').hide();

    this.updateParameters(key, value);
    this.handleRequest();
  }

  removeArray(that, e) {
    e.preventDefault();

    const self = $(that);
    const key = self.data('key');
    const value = self.data('value');
    $(`#${key}-${value}`).toggleClass('active');
    $(`#${key}-${value}`).toggleClass('inactive');
    console.log(`#${key}-${value}`);
    this.updateParameters(key, value);
    this.handleRequest();
  }
  handleLoadMore() {
    if (!this.hasMore && +this.maxItems > +this.currentPage) {
      this.currentPage++;

      this.handleRequest(true);
    }
  }

  handleOrderBy(that) {
    $(that).siblings('.sort-options').removeClass('active');
    $(that).siblings('.sort-options').addClass('inactive');
    const orderBy = $(that).data('value');
    $(that).toggleClass('active');
    $(that).toggleClass('inactive');
    this.updateParameters('orderby', orderBy, true);
    this.handleRequest();
  }

  handleRemoveMobile(self) {
    this.updateParameters($(self).data('key'));
    this.handleRequest();
  }

  handleReset() {
    window.history.replaceState({}, '', location.pathname);

    $('.filter-reset li').remove();
    $('.filter-reset').hide();
    $('.filter-type.categories').show();
    $('.filter-item').removeClass('active');
    $('.filter-item').addClass('inactive');
    this.handleRequest();
  }



  handleRequest(append = false) {
    const urlParams = this.getUrlParams();

    let params = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });

    if (!append) this.currentPage = 1;

    $.ajax({
      url: this.url,
      method: 'POST',
      data: {
        nonce: this.nonce,
        action: this.action,
        parent: this.parent,
        term_id: this.term_id,
        paged: this.currentPage,
        params: JSON.stringify(params),
      },
      beforeSend: () => {
        if (append) {
          this.loader.show();
          this.hasMore = true;
        } else {
          $('.mana-type').show();
          this.container.css('opacity', '0.3').css('pointer-events', 'none');
          $('.container .filter-options').animate({ opacity: '0.3' });
        }
      },
    })
      .done((response) => {
        if (append) {
          this.productsContainer.append(response.products);
        } else {
          if(response.total > 0){
            this.productsContainer.html(response.products);
          }else{
            this.productsContainer.html('<h1 class="product-not-found" style="text-align: center;width: 100%;">Products not found</h1>');
          }
          $('.container .filter-options').replaceWith(response.filters);
          $('.filter .dropdown-filter').html(response.filters_mobile);
          $('.list-author').html(response.test)
          /* Update results count */
          this.total.html(
            `${response.total} ${response.total > 1 ? 'Results' : 'Result'}`
          );
        }
      })
      .fail(() => {
        if (append) this.currentPage--;
      })
      .always(() => {
        if (append) {
          this.loader.hide();
          this.hasMore = false;
        } else {
          $('.mana-type').hide();

          setTimeout(() => {
            $('.container .filter-options').animate({ opacity: '1' });
            this.container.css('opacity', '1').css('pointer-events', 'auto');
          }, 500);
        }
      });
  }

}
